import baseScmService from 'services/baseScmService';

const academyTopicService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getAcademyTopic: build.query({
      query: (academyTopicId) => ({
        url: `/academy-topics/${academyTopicId}`,
      }),
      providesTags: (result, error, academyTopicId) => {
        return error ? [] : [{ type: 'AcademyTopic', id: academyTopicId }];
      },
    }),
    updateAcademyTopic: build.mutation({
      query: ({ academyTopicId, academyTopic }) => ({
        method: 'PUT',
        url: `/academy-topics/${academyTopicId}`,
        body: {
          academy_topic: {
            title: academyTopic.title,
            junction_number: academyTopic.junction_number,
            academy_module_id: academyTopic.academy_module?.id,
            bucket_id: academyTopic.lecture_bucket?.id || null,
          },
        },
      }),
      invalidatesTags: (result, error, { academyTopicId }) =>
        error ? [] : [{ type: 'AcademyTopic', id: academyTopicId }],
    }),
    ingestAcademyTopicPlaylist: build.mutation({
      query: ({ academyTopic, content }) => ({
        method: 'POST',
        url: `/academy-topics/${academyTopic.id}/playlists`,
        body: {
          content,
        },
      }),
      invalidatesTags: (result, error, { academyTopic, playlistId }) =>
        error
          ? []
          : [
              { type: 'AcademyTopic', id: academyTopic.id },
              { type: 'Playlist', id: playlistId },
            ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAcademyTopicQuery,
  useIngestAcademyTopicPlaylistMutation,
  useUpdateAcademyTopicMutation,
} = academyTopicService;

export default academyTopicService;
